import * as React from 'react';

// Utils
import { isNotNil } from '@src/shared/src/util/general';
// Constants
// Actions, Models & Interfaces
import { CoordinatesModel } from '@src/shared/src/models';
// Components
import { AdvancedMarker } from '@vis.gl/react-google-maps';
// Styles
import '../styles/HotelMapMarker.scss';

type Props = {
  position: CoordinatesModel;
};

const HotelDestMarker: React.FC<Props> = ({ position }) => {
  if (isNotNil(position)) {
    return (
      <AdvancedMarker position={new google.maps.LatLng(position.lat, position.lng)}>
        <div className="hotel-map-marker-dest material-symbols">location_on</div>
      </AdvancedMarker>
    );
  }
};

export default HotelDestMarker;
